import React from "react";
import { FormRuntime } from "../../FormRuntime";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";
import { FormConfiguration } from "../../FormConfiguration";

export const RichTextEditorFormControlsStories = [
    new StoryNode(
        () => {
            return <FormRuntime form={new FormConfiguration()}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Rich Text Editor - MISSING"
    ),
];
